function popupCheck() {
  if (document.querySelectorAll('.Checkbox__input') != null) {
    const popupInput = document.querySelectorAll('.Checkbox__input')
    const popupFooterBtn = document.querySelectorAll(
      '.popup-interior-door__footer',
    )
    try {
      window.addEventListener('click', event => {
        if (event.target.closest('.pick-up-classic')) {
          let parentLi = event.target.closest('LI')
          if (parentLi && parentLi.querySelector('input').checked) {
            parentLi.classList.add('popup-interior-door__item--active')
          } else {
            parentLi.classList.remove('popup-interior-door__item--active')
            popupCounter()
          }
          let eventInput = event.target
            .closest('.pick-up-classic')
            .querySelectorAll('.Checkbox__input')
        } else if (event.target.closest('.pick-up-molding')) {
          let parentLi = event.target.closest('LI')
          if (parentLi && parentLi.querySelector('input').checked) {
            parentLi.classList.add('popup-interior-door__item--active')
          } else {
            parentLi.classList.remove('popup-interior-door__item--active')
            popupCounter()
          }
          let eventMou = event.target
            .closest('.pick-up-molding')
            .querySelectorAll('.Checkbox__input')
        }
      })
    } catch {
    }
  }
}
